module.exports = __webpack_public_path__ + "img/3_user.ab8f85b9.svg";